/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface CopyLinkDialogData {
  title: string;
  link: string;
}

@Component({
  selector: 'app-copy-link-dialog',
  templateUrl: './copy-link-dialog.component.html',
  styleUrl: './copy-link-dialog.component.scss',
})
export class CopyLinkDialogComponent {
  title: string;
  link: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: CopyLinkDialogData,
    private snackBar: MatSnackBar,
  ) {
    this.title = data.title;
    this.link = data.link;
  }

  showNotification(): void {
    this.snackBar.open('Copied link to clipboard!', 'Close', {
      duration: 2500,
    });
  }
}
